import React, { useState, useEffect } from 'react';

const CustomForm2 = ({
  confidenceLevelUser, 
  labelOfMyEdges, 
  numerEdge, 
  acceptEdgePredicted, 
  buttonPressed, 
  veryGoodConfidenceRate,
  goodConfidenceRate,
  badConfidenceRate,
  veryBadConfidenceRate
}) => {

  const [value, setValue] = useState(0.0);
  const [selectEdges, setSelectEdges] = useState({});   //object family, selected(bool)
  const [press, setPress] = useState(null);
  const [edgeRate, setEdgeRate] = useState('');

  const handleChange = (event) => {
    setPress(null);
    setValue(parseFloat(event.target.value));
    confidenceLevelUser(parseFloat(event.target.value));
  };

  const handleMouseEnter = (event) => {
    event.target.style.backgroundColor = 'rgb(150, 150, 150)';
  };

  const handleMouseLeave = (event) => {
    event.target.style.backgroundColor = 'rgb(200, 200, 200)';
  };

  const acceptEdges = () => {
    setPress(true)
  };

  const declineEdges = () => {
    setPress(false)
  };

  useEffect(() => {
    buttonPressed(press)
    if (press !== null) {
      const timeoutId = setTimeout(() => {
        setPress(null);
      }, 0.1); //set the time in milliseconds after which you want to reset the press variable to null
      return () => clearTimeout(timeoutId);
    }
  },[press, buttonPressed])

  useEffect(() => {
    //initializes all checkboxes to true when the component mounts (so when I refresh)
    const initialCheckedState = {};
    // eslint-disable-next-line
    labelOfMyEdges.map((family) =>  {
      initialCheckedState[family] = {selected:true};
    });
    setSelectEdges(initialCheckedState);
  }, [labelOfMyEdges]);

  useEffect(() =>{
    acceptEdgePredicted(selectEdges);
  },[selectEdges, acceptEdgePredicted])

  const handleSave = () => {
    if (edgeRate === 'very good') {
      veryGoodConfidenceRate();
    }
    else if (edgeRate === 'good') {
      goodConfidenceRate();
    }
    else if (edgeRate === 'bad') {
      badConfidenceRate();
    }
    else {
      veryBadConfidenceRate();
    }
  }
  
  let txt_clr = '';
  if (edgeRate === 'very good') {
      txt_clr = 'vg-txt'; 
  }
  else if (edgeRate === 'good') {
      txt_clr = 'g-txt';
  }
  else if (edgeRate === 'bad') {
      txt_clr = 'b-txt';
  }
  else {
      txt_clr = 'vb-txt';
  }


  return (
    <div style={styles.container}>

      <div class="modal fade" id="confModal" tabindex="-1" aria-labelledby="confModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="confModalLabel">Rate the edge plausibility</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p className={txt_clr}>Do you want to rate the edges as <strong>{edgeRate}</strong>?</p>
            </div>
            <div class="modal-footer">
              <button type="button" data-bs-dismiss="modal" class="btn btn-outline-success" onClick={handleSave}>Save</button>
            </div>
          </div>
        </div>
      </div>
      
      <p style={{ textAlign:'center', marginBottom: '0', margin: 'auto' }}>Value of confidence: {value.toFixed(2)}
      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={value}
        onChange={handleChange}
        style={{ width: '70%', cursor: 'grab' }}
      />
      </p>
      {labelOfMyEdges.length > 0 ? (
      <div>
        <table style={{ width: '100%', textAlign: 'center', margin: 'auto' }}>
          <thead style={{ fontSize: '80%' }}>
            <tr>
              <th style={{ borderBottom: '2px solid black' }}>Edges</th>
              <th style={{ borderBottom: '2px solid black' }}>Type of edges</th>
              <th style={{ borderBottom: '2px solid black' }}>Select</th>
            </tr>
          </thead>
          <tbody style={{ maxHeight: '10vh', overflowY: 'auto' }}>
            {labelOfMyEdges.map((family, index) => (
              <tr key={index}>
                <td style={{ fontSize: '70%' }}>
                  <strong>{numerEdge[family]}</strong>
                </td>
                <td style={{ fontSize: '70%' }}>
                  <strong>{family}</strong>
                </td>
                <td>
                  <input
                    type="checkbox"
                    id={family}
                    style={{
                      cursor: 'pointer',
                      transform: 'scale(1.5)',
                    }}
                    onChange={() => {
                      setSelectEdges((prevViewEdges) => ({
                        ...prevViewEdges,
                        [family]: {
                          ...prevViewEdges[family],
                          selected: !prevViewEdges[family].selected,
                        },
                      }));
                    }}
                    checked={selectEdges[family]?.selected || false}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <br />

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <button 
            className="rate-btn verygood" 
            data-bs-toggle='modal' 
            data-bs-target='#confModal' 
            onClick={()=> {
            const backdrops = document.querySelectorAll('.modal-backdrop');
            for (let i = 0;i < 2;i++) {
              backdrops[i].remove();
            }
            setEdgeRate('very good')}}>
              &#128512;
          </button>

          <button 
            className="rate-btn good" 
            data-bs-toggle='modal' 
            data-bs-target='#confModal' 
            onClick={()=> {
            const backdrops = document.querySelectorAll('.modal-backdrop');
            for (let i = 0;i < 2;i++) {
              backdrops[i].remove();
            }
            setEdgeRate('good')}}>
              &#128578;
          </button>

          <button 
            className="rate-btn bad" 
            data-bs-toggle='modal' 
            data-bs-target='#confModal' 
            onClick={()=> {
            const backdrops = document.querySelectorAll('.modal-backdrop');
            for (let i = 0;i < 2;i++) {
              backdrops[i].remove();
            }
            setEdgeRate('bad')}}>
              &#128577;
          </button>

          <button 
            className="rate-btn verybad" 
            data-bs-toggle='modal' 
            data-bs-target='#confModal' 
            onClick={()=> {
            const backdrops = document.querySelectorAll('.modal-backdrop');
            for (let i = 0;i < 2;i++) {
              backdrops[i].remove();
            }
            setEdgeRate('very bad')}}>
              &#128553;
          </button>

          {/* <button
            style={{
              flex: '1',
              padding: '3vh',
              font: 'bold',
              borderRadius: '4px',
              cursor: 'pointer',
              backgroundColor: 'rgb(200, 200, 200)',
              color: 'green',
              border: '1px solid green',
              transition: 'background-color 0.3s',
              marginRight: '2%', // Aggiunto margine a destra
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={acceptEdges}
          >
            <span>Accept</span>
          </button>
          <button
            style={{
              flex: '1',
              padding: '3vh',
              font: 'bold',
              borderRadius: '4px',
              cursor: 'pointer',
              backgroundColor: 'rgb(200, 200, 200)',
              color: 'red',
              border: '1px solid red',
              transition: 'background-color 0.3s',
              marginLeft: '5px', // Aggiunto margine a sinistra
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={declineEdges}
          >
            <span>Decline</span>
          </button> */}
        </div>
        <span style={styles.subtitiles}>select the edges level you want to view and decide which rate you want to give.</span>
      </div>
      
    ) : (
      <p>There are no edges to rate.</p>
    )}
      
    </div>
  );
};


const styles = {
  container: {
    margin: 'auto',
    backgroundColor: "white",
    paddingTop: 0,
    paddingLeft: 7,
    paddingRIght: 7,
    paddingBottom: 5,
    textAlign: 'center',
  },
  subtitiles: {
    fontSize: '70%',
    color: "black",
  },
};  

export default CustomForm2;